import axios from 'axios';
import { logErrorToConsole } from '../../constants';

const axiosInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL || 'https://www.travelwitsapi.com',
  // baseURL: 'http://localhost:5000',
  // baseURL: 'http://travelwitsapi.web3.travelwits.com',
});

// Add a request interceptor to attach the Page Access Code (PAC) header to outgoing requests.
axiosInstance.interceptors.request.use((config) => {
  try {
    if (config.headers.Authorization) {
      return config; // If Authorization header is present, do not add PAC header.
    }

    const pacCookie = document.cookie?.split('; ')?.find((row) => row?.startsWith('twpac='))?.replace('twpac=', '');

    if (pacCookie) {
      // eslint-disable-next-line no-param-reassign
      config.headers = {
        ...config.headers,
        pac: pacCookie,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      };
    }
  } catch (e) {
    logErrorToConsole('PAC header error:', e);
  }

  return config;
}, (error) => Promise.reject(error));

export default axiosInstance;
